export const REDIRECT_404 = 'REDIRECT_404';
export const redirect404 = redirectUrl => ({
  type: REDIRECT_404,
  redirectUrl
});
